export const LICENSE_LOADING = 'LICENSE_LOADING';
export const GET_LICENSES_CUSTOMER = 'GET_LICENSES_CUSTOMER';
export const GET_DETAIL_LICENSES_CUSTOMER = 'GET_DETAIL_LICENSES_CUSTOMER';
export const SET_CHIPS_FILTERS_LICENSES = 'SET_CHIPS_FILTERS_LICENSES';
export const CHANGE_CHIPS_FILTERS_LICENSES = 'CHANGE_CHIPS_FILTERS_LICENSES';
export const CLEAR_LICENSES_CUSTOMER = 'CLEAR_LICENSES_CUSTOMER';
export const ADD_LICENSE_CUSTOMER = 'ADD_LICENSE_CUSTOMER';
export const LICENSE_SHOW_MESSAGE = 'LICENSE_SHOW_MESSAGE';
export const GET_CUSTOMER_INFORMATION_LICENSE = 'GET_CUSTOMER_INFORMATION_LICENSE';
export const GET_LICENSE_INFORMATION = 'GET_LICENSE_INFORMATION';
export const GET_MANAGERS = 'GET_MANAGERS';
export const GET_APP_PARAMETERS_CONTRACTS = 'GET_APP_PARAMETERS_CONTRACTS';
export const GET_CONTRACT_DATA = 'GET_CONTRACT_DATA';
export const GET_SERVICES_DATA_DASHBOARD = 'GET_SERVICES_DATA_DASHBOARD';
export const GET_DETAIL_CONTRACTS = 'GET_DETAIL_CONTRACTS';
export const GET_HISTORY_CONSUMPTION_DASHBOARD = 'GET_HISTORY_CONSUMPTION_DASHBOARD';
export const GET_REQUEST_DASHBOARD = 'GET_REQUEST_DASHBOARD';
export const GET_CONTRACT_CUSTOMER_INFO = 'GET_CONTRACT_CUSTOMER_INFO';
export const GET_CONTRACT_SUPERVISOR_INFO = 'GET_CONTRACT_SUPERVISOR_INFO';
export const GET_CONTRACT_DETAILS = 'GET_CONTRACT_DETAILS';
export const GET_AGREEMENTS_LIST = 'GET_AGREEMENTS_LIST';
export const GET_INFORMATION_AGREEMENT = 'GET_INFORMATION_AGREEMENT';
export const MODIFY_INFORMATION_AGREEMENT = 'MODIFY_INFORMATION_AGREEMENT';
export const LICENSE_LOADING_UPDATE_AGREEMENT = 'LICENSE_LOADING_UPDATE_AGREEMENT';
export const GET_RISK_OFFICERS = 'GET_RISK_OFFICERS';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const LOADING_MARKET_PLACE = 'LOADING_MARKET_PLACE';
export const UPDATE_LOCAL_QUANTITY = 'UPDATE_LOCAL_QUANTITY';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
export const UPDATE_LICENSE_DATA = 'UPDATE_LICENSE_DATA';
export const DELETE_LICENSE_ASSIGNMENT = 'DELETE_LICENSE_ASSIGNMENT';
export const GET_CART_ERROR = 'GET_CART_ERROR';
export const LICENSE_LOADING_SAVE_ORDER = 'LICENSE_LOADING_SAVE_ORDER';
export const GET_ITEMS_CATALOG = 'GET_ITEMS_CATALOG';
export const UPDATE_CART_ITEM_FULL = 'UPDATE_CART_ITEM_FULL';
export const LOADING_LOAD_PRODUCTS_ASSIGNMENTS = 'LOADING_LOAD_PRODUCTS_ASSIGNMENTS';
export const LICENSE_SAVE_ORDER_SUCCESS = 'LICENSE_SAVE_ORDER_SUCCESS';
export const SET_MARKET_CONTEXT = 'SET_MARKET_CONTEXT';
export const SAVE_ASSIGNMENTS_SUCCESS = 'SAVE_ASSIGNMENTS_SUCCESS';
export const SAVING_ASSIGNMENTS_LOADING = 'SAVING_ASSIGNMENTS_LOADING';
export const SAVE_ORDER_SUCCESS = 'SAVE_ORDER_SUCCESS';
export const SAVE_ORDER_MARKET_ERROR = 'SAVE_ORDER_MARKET_ERROR';
export const PRODUCT_WAS_ASSIGNED = 'PRODUCT_WAS_ASSIGNED';
export const PAYMENT_RESULT = 'PAYMENT_RESULT';
export const ADD_PROMO_TO_LIST = 'ADD_PROMO_TO_LIST';
export const LOADING_VALIDATE_PROMO_CODE = 'LOADING_VALIDATE_PROMO_CODE';
export const SET_PROMO_FEEDBACK = 'SET_PROMO_FEEDBACK';
export const LOADING_CONTRACT_CUSTOMER_INFO = 'LOADING_CONTRACT_CUSTOMER_INFO';
export const LOADING_CONTRACT_SUPERVISOR_INFO = 'LOADING_CONTRACT_SUPERVISOR_INFO';
export const COUNTRIES_FLAGS = 'COUNTRIES_FLAGS';
export const CUSTOMER_ASSIGNED_CONTRACTS = 'CUSTOMER_ASSIGNED_CONTRACTS';
export const CLEAR_SERVICES_DATA_DASHBOARD = 'CLEAR_SERVICES_DATA_DASHBOARD';
export const GET_CUSTOMER_EDIT_INFORMATION_LICENSE = 'GET_CUSTOMER_EDIT_INFORMATION_LICENSE';
export const LOADING_CUSTOMER_EDIT_INFORMATION = 'LOADING_CUSTOMER_EDIT_INFORMATION';
export const LICENSE_LOADING_UPDATE_CUSTOMER = 'LICENSE_LOADING_UPDATE_CUSTOMER';
export const LOADING_CONTRACT_ANNULMENT = 'LOADING_CONTRACT_ANNULMENT';
export const CONTRACT_ANNULMENT = 'CONTRACT_ANNULMENT';